/* istanbul ignore file */
export const deviceTypes = {
  PHONE: 'PHONE',
  TABLET: 'TABLET',
  DESKTOP: 'DESKTOP',
  DESKTOPALT: 'DESKTOPALT',
  PHONEALT1: 'PHONEALT1',
  PHONEALT2: 'PHONEALT2',
};

export const BREAKPOINTS = {
  [deviceTypes.PHONE]: { max: 599 },
  [deviceTypes.TABLET]: { min: 600, max: 1023 },
  [deviceTypes.DESKTOP]: { min: 1024 },
};

export const deviceProductsPerRow = {
  [deviceTypes.PHONE]: 2,
  [deviceTypes.TABLET]: 4,
  [deviceTypes.DESKTOP]: 4,
  [deviceTypes.DESKTOPALT]: 6,
  [deviceTypes.PHONEALT1]: 3,
  [deviceTypes.PHONEALT2]: 1,
};

export const altGridViewColumnMapping = {
  [1]: { label: '1 column', view: 'portrait' }, // mobile
  [2]: { label: '2 column', view: 'default' }, // mobile
  [3]: { label: '3 column', view: 'small' }, // mobile
  [4]: { label: '4 column', view: 'default' }, // desktop
  [6]: { label: '6 column', view: 'small' }, // desktop
};

export const pageTypes = {
  SUBSPLASH: 'SUB_SPLASH',
  BROWSE: 'BROWSE',
  SEARCH: 'SEARCH',
  SPLASH: 'SPLASH',
  BRANDINDEX: 'BRAND_INDEX',
  BRANDSCATEGORYPAGE: 'BRANDSCATEGORYPAGE',
};

export const pageTypesLiteral = {
  subSplash: 'subSplash',
  zeroSearchResults: 'zeroSearchResults',
  browse: 'browse',
  search: 'search',
  catSplash: 'catSplash',
  brandIndex: 'brandIndex',
  brandsCategoryPage: 'brandsCategoryPage',
};

export const midContClassNames = {
  LARGE12: 'large-12',
  LARGE9: 'large-9',
};

export const phoneNumbers = {
  mcom: '1-800-289-6229',
  bcom: '1-800-777-0000',
};

export const BOPS_NAME = 'Upc_bops_purchasable';
export const SDD_FACET = 'Upc_sdd_purchasable';

export const addToBagCookies = {
  signedIn: 'SignedIn',
  miscGCs: 'MISCGCs',
  lastReviewUsername: 'last_review_username',
  productsReviewed: 'products_reviewed',
  shippingCountry: 'shippingCountry',
  currency: 'currency',
  secureUserToken: 'secure_user_token',
  csl: 'CSL', // current store location
  bopsPickupInStore: 'BOPSPICKUPSTORE',
  zipCode: 'USERPC',
  bigTicketZipCode: 'BTZIPCODE',
  forwardPageURL: 'FORWARDPAGE_KEY',
};

export const FF_SEARCH_QUERY = '_ffSearchQuery';

/**
 * One Click Sale Facet
 */
export const ocsFacet = {
  SPECIAL_OFFER: 'special offer',
  GWP: 'gift with purchase',
  FREE_SHIPPING: 'free shipping',
  LOYALLIST_POINTS_OFFERS: 'loyallist points offers',
  SPECIAL_OFFERS_FACET: 'SPECIAL_OFFERS',
};

/**
 * Centralized facet limits used by horizontal facet bars.
 * Note: These are also defined as fallback defaults in FilteringFacets global options.
 */
export const MAX_FACET_FILTERS = {
  DESKTOP: 7,
  TABLET: 6,
};

/**
 * Big Ticket Delivery Facet Constants
 */
export const BT_DELIVERY_FACET_NAME = 'UPC_DELIVERABLE';
export const BT_DELIVERY_UI_NAME = 'Delivery';
export const BT_DELIVERY_TYPE = 'BT_DELIVERY';
export const BT_DELIVERY_PREFIX = 'DELIVERABLE=';
export const BT_DELIVERY_PATH_NAME = 'Upc_deliverable';
